<template>
  <Form :reset.sync="reset" :onetimeToken="onetimeToken"></Form>
</template>

<script>
export default {
  name: 'ResetPasswordForm',
  components: {
    Form: () => import('../../components/cloud/ResetPass/Form.vue')
  },
  props: {
    reset: Object
  },
  computed: {
    onetimeToken() {
      return this.$route.params.onetimeToken
    }
  },
  created(){
    const args = {
      onetime_token: this.onetimeToken,
        __apiOptions: { noErrorDialog: true }
    }
    this.$store.dispatch('api/checkTokenActive', args).then(() => {
      if (this.$store.getters['api/apiError']) {
        this.$router.push({ name: 'request-password-reset' , query: { expired: true }})
        return;
      }
    })
  }
}
</script>

<style scoped>
</style>